/**
 * Pure decision logic for the portal push setup. React/network-free so
 * it can be unit-tested (repo convention).
 */

const THIRTY_DAYS_MS = 30 * 24 * 60 * 60 * 1000;

export type InstallPlatform = "installed" | "ios" | "android" | "desktop";

export function urlBase64ToUint8Array(base64String: string): Uint8Array {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const rawData = atob(base64);
  const output = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; i += 1) {
    output[i] = rawData.charCodeAt(i);
  }
  return output;
}

export function isPushSupported(): boolean {
  return (
    typeof window !== "undefined" &&
    "serviceWorker" in navigator &&
    "PushManager" in window &&
    "Notification" in window
  );
}

export function installPlatform(
  userAgent: string,
  standalone: boolean
): InstallPlatform {
  if (standalone) return "installed";
  if (/iPhone|iPad|iPod/i.test(userAgent)) return "ios";
  if (/Android/i.test(userAgent)) return "android";
  return "desktop";
}

export function shouldShowInstallBanner(
  platform: string,
  dismissedAt: number | null,
  now: number
): boolean {
  if (platform !== "ios" && platform !== "android") return false;
  if (dismissedAt !== null && now - dismissedAt < THIRTY_DAYS_MS) return false;
  return true;
}

export function shouldShowPermissionCard(
  permission: NotificationPermission,
  deniedAt: number | null,
  now: number
): boolean {
  if (permission !== "default") return false;
  if (deniedAt !== null && now - deniedAt < THIRTY_DAYS_MS) return false;
  return true;
}
